module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/stack_add_graphic_portrait@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/stack_add_graphic_portrait@1x.png
// module id = 716
// module chunks = 0